import { IWidgetSettings } from '../../../reducers/widget'
import { IItemData } from '../fetchWidget'

export default function mapValuesToRequest(
  widgets: IWidgetSettings,
  objectId,
): Partial<IItemData> {
  return {
    regulation_setting:
      widgets.regulation_radio === 'regulation_url' ? '1' : '2',
    regulation_text: widgets.regulation_text,
    show_food: widgets.feeding_option ? '1' : '0',
    privacy_setting: widgets.policy_radio === 'policy_url' ? '1' : '2',
    show_food_bb: widgets.feeding_option_bb ? '1' : '0',
    privacy_text: widgets.policy_text,
    show_food_fb: widgets.feeding_option_fb ? '1' : '0',
    id_object: objectId,
    show_food_hb: widgets.feeding_option_hb ? '1' : '0',
    language: widgets.lang,
    show_kids_price: widgets.kids_price ? '1' : '0',
    privacy_url: widgets.policy_url,
    hide_link: widgets.hide_url ? '1' : '0',
    regulation_url: widgets.regulation_url,
    widget_color: widgets.color,
    subdomain: widgets.subdomain,
    show_calendar: widgets.show_calendar ? '1' : '0',
    no_reservation_online: widgets.no_reservation_online ? '1' : '0',
    block_reservations: widgets.block_reservations ? '1' : '0',
  }
}
